const atylMenu = KTMenu;
const atylOffcanvas = KTOffcanvas;
const atylScrollTop = KTScrolltop;
const atylHeader = KTHeader;
const atylToggle = KTToggle;
const atylUtil = KTUtil;
const atylDialog = KTDialog;
